import React from "react";
// import { useSelector } from "react-redux";

import makeStyles from "@material-ui/styles/makeStyles";
import SyncIcon from "@material-ui/icons/Sync";

// import { Create, BooleanInput, Edit, List, SimpleForm, TextInput, TextField, Button } from "jazasoft";
import { Create, BooleanInput, Edit, List, SimpleForm, TextInput, TextField, Button, CreateButton, EditButton, DeleteButton } from "jazasoft";

import Datagrid from "../../components/Datagrid";
// import HistoryButton from "../../components/LibraryHistoryButton";

import { useMutation } from "../../hooks";
import { useSetting } from "../../hooks";
import SettingKeys from "../../utils/SettingKeys";
import { UnitFields } from "../../utils/entityFields";
import getValidation from "../../utils/getValidation";
import { Role } from "../../utils/types";
// import { ResourceId, Scope } from "../../utils/privilege";
// import hasPrivilege from "../../utils/hasPrivilege";

export const CreateUnit = props => {
  const fields = useSetting(SettingKeys.ENTITY_FIELDS, props.resource);
  const validationRule = useSetting(SettingKeys.ENTITY_FIELD_VALIDATION, props.resource);
  return (
    <Create {...props}>
      <SimpleForm redirect="home">
        {fields.includes(UnitFields.NAME) && <TextInput source="name" validate={getValidation(validationRule[UnitFields.NAME])} />}
        {fields.includes(UnitFields.UNIT_ID) && <TextInput source="unitId" validate={getValidation(validationRule[UnitFields.UNIT_ID])} />}
        {fields.includes(UnitFields.REGION) && <TextInput source="region" validate={getValidation(validationRule[UnitFields.REGION])} />}
        {fields.includes(UnitFields.DESC) && <TextInput validate={getValidation(validationRule[UnitFields.UNIT_ID])} source="desc" />}
      </SimpleForm>
    </Create>
  );
};

export const EditUnit = props => {
  // const record = useSelector(
  //   state =>
  //     state.jazasoft.resources[props.resource] &&
  //     state.jazasoft.resources[props.resource].data &&
  //     state.jazasoft.resources[props.resource].data[props.id]
  // );

  const fields = useSetting(SettingKeys.ENTITY_FIELDS, props.resource);
  const validationRule = useSetting(SettingKeys.ENTITY_FIELD_VALIDATION, props.resource);
  return (
    <Edit {...props}>
      <SimpleForm redirect="home" form="record-form-edit">
        {fields.includes(UnitFields.NAME) && (
          <TextInput source="name" validate={getValidation(validationRule[UnitFields.NAME])} options={{ fullWidth: true }} />
        )}
        {fields.includes(UnitFields.UNIT_ID) && (
          <TextInput source="unitId" validate={getValidation(validationRule[UnitFields.UNIT_ID])} options={{ fullWidth: true }} />
        )}
        {fields.includes(UnitFields.REGION) && (
          <TextInput source="region" validate={getValidation(validationRule[UnitFields.REGION])} options={{ fullWidth: true }} />
        )}
        {fields.includes(UnitFields.DESC) && <TextInput validate={getValidation(validationRule[UnitFields.UNIT_ID])} source="desc" />}
        <BooleanInput source="enabled" xs={12} sm={3} />
      </SimpleForm>
    </Edit>
  );
};

const useHomeStyle = makeStyles(theme => ({
  buttonEdit: {
    width: theme.spacing(14)
  },
  buttonDelete: {
    width: theme.spacing(16)
  },
  buttonHistory: {
    width: theme.spacing(1)
  }
}));

export const UnitHome = props => {
  // const { roles, hasAccess } = props;
  const { roles } = props;
  const classes = useHomeStyle();
  const fields = useSetting(SettingKeys.ENTITY_FIELDS, props.resource);

  // const { disableCreate, disableEdit, disableDelete } = useEntityPrivilege("unit");

  const [mutate] = useMutation();

  const onSync = () => {
    const options = { url: `units`, method: "get", params: { action: "sync" } };
    mutate(options);
  };

  const isMasterOrSuperUser = roles?.includes(Role.MASTER) || roles?.includes(Role.SUPER_USER);

  return (
    <List
      actions={({ basePath, roles = [] }) => (
        <div>
          {/* {hasPrivilege(roles, hasAccess, ResourceId.UNIT, Scope.WRITE) && !disableCreate && <CreateButton basePath={basePath} showLabel={false} />} */}
          {isMasterOrSuperUser && <CreateButton basePath={basePath} showLabel={false} />}
          <Button showLabel={false} label="Sync" onClick={onSync}>
            <SyncIcon />
          </Button>
        </div>
      )}
      {...props}>
      <Datagrid classes={{ headerCell: classes.headerCell, rowCell: classes.rowCell }}>
        {fields.includes(UnitFields.NAME) && <TextField source="name" />}
        {fields.includes(UnitFields.UNIT_ID) && <TextField source="unitId" />}
        {fields.includes(UnitFields.REGION) && <TextField source="region" />}
        {fields.includes(UnitFields.DESC) && <TextField source="desc" />}
        {/* {hasPrivilege(roles, hasAccess, ResourceId.UNIT, Scope.UPDATE) && !disableEdit && <EditButton cellClassName={classes.buttonEdit} />} */}
        {/* {hasPrivilege(roles, hasAccess, ResourceId.UNIT, Scope.DELETE) && !disableDelete && <DeleteButton cellClassName={classes.buttonDelete} />} */}
        {isMasterOrSuperUser && <EditButton cellClassName={classes.buttonEdit} />}
        {isMasterOrSuperUser && <DeleteButton cellClassName={classes.buttonDelete} />}
        {/* <HistoryButton cellClassName={classes.buttonHistory} i18nKey={props.i18nKey} /> */}
      </Datagrid>
    </List>
  );
};
